export const checkAddToCartAllow = ({
  data,
  allItems,
  callback,
  onError,
}: {
  data: any;
  allItems: Array<any>;
  callback: any;
  onError: any;
}) => {
  console.log(allItems);
  if (allItems?.length > 0) {
    // check user
    const userId = allItems[0]?.listings?.user_id ?? 0;
    if (userId !== data.user_id) {
      // not allow if userId is differ
      onError(
        "The vendor is not matched with the vendor equipment you have added into cart, Please select the equipments from same vendors or clear your cart."
      );
      return false;
    }

    const checkHasAdded = allItems.filter(
      (item: any) => item.listing_id === data.id
    );
    if (checkHasAdded.length > 0) {
      // not allow if already added to cart
      onError("This equipment is added already into cart.");
      return false;
    }

    callback();
  } else {
    callback();
  }
};

export const checkHasAddedToCart = (data: any, allItems: any) => {
  const checkHasAdded = allItems.filter(
    (item: any) => item.listing_id === data.id
  );
  if (checkHasAdded.length > 0) {
    // not allow if already added to cart
    return true;
  }

  return false;
};

export const getItemCartId = (data: any, allItems: any) => {
  const checkHasAdded = allItems.filter(
    (item: any) => item.listing_id === data.id
  );
  if (checkHasAdded.length > 0) {
    // not allow if already added to cart
    return checkHasAdded[0].id;
  }

  return 0;
};

export const setCartCache = (data: any) => {
  window.localStorage.setItem("cartCache", JSON.stringify(data));
};

export const getCartCache = () => {
  const cache = window.localStorage.getItem("cartCache");
  return cache ? JSON.parse(cache) : null;
};

export const clearCartCache = () => {
  window.localStorage.removeItem("cartCache");
};
